import { ButtonReset } from '@helpers/global';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';
const Button = styled.button `
  ${ButtonReset}

  position: fixed;
  top: 0;
  right: 0;
  display: grid;
  background: var(--bgColor);
  color: var(--fgColor);
  height: var(--buttonSize);
  place-content: center;
  place-items: center;
  width: var(--buttonSize);
  z-index: 1;
  transform: translate(-50%, 50%);

  svg {
    display: block;
    height: 100%;
    width: 100%;
  }

  &.focus-ring {
    outline: auto;
  }

  @media ${from(Device.TabletLarge)} {
    position: absolute;
    transform: translateY(-150%);
  }
`;
const CloseStyles = {
    Button,
};
export default CloseStyles;
